import { EventEmitter, Injectable } from "@angular/core";

@Injectable({
    providedIn: "root"
})
export class GenericService {
    public onNewCalled = new EventEmitter<unknown>();
    public onEditCalled = new EventEmitter<unknown>();
    public onImportCalled = new EventEmitter<unknown>();
    public onDownloadTemplateCalled = new EventEmitter<unknown>();
    public onDownloadClaimCalled = new EventEmitter<unknown>();
    public onExportCalled = new EventEmitter<string>();
    public onSaveCalled = new EventEmitter<unknown>();
    public onDeleteCalled = new EventEmitter<unknown>();
    public onGoBackCalled = new EventEmitter<unknown>();
    public onOpenSetUnavailabilityCalled = new EventEmitter<unknown>();
    public onTableInfoChangeCalled = new EventEmitter<unknown>();
    public onAddAttachmentCalled = new EventEmitter<unknown>();
}
